import html2canvas from 'html2canvas'

const DEFAULT_CANVAS_IMAGE_TYPE = 'image/png'

if (!HTMLElement.prototype.insertAfter) {
    // https://stackoverflow.com/questions/4793604/how-to-insert-an-element-after-another-element-in-javascript-without-using-a-lib
    HTMLElement.prototype.insertAfter = function (newNode) {
        if (!(newNode instanceof HTMLElement)) {
            throw 'insertAfter requires a HTMLElement to insert after the existing'
        }
        return this.insertAdjacentElement('afterend', newNode)
    }
}

if (!NodeList.prototype.any) {
    NodeList.prototype.any = function (condition) {
        if (condition) {
            for (var i = 0; i < this.length; i++) {
                if (condition(this[i])) {
                    return !!this[i]
                }
            }
        }
        return this.length > 0
    }
}

if (!NodeList.prototype.find) {
    NodeList.prototype.find = function (condition) {
        if (condition) {
            for (var i = 0; i < this.length; i++) {
                if (condition(this[i])) {
                    return this[i]
                }
            }
        }
        return this[0] ? this[0] : null
    }
}

if (!NodeList.prototype.last) {
    NodeList.prototype.last = function () {
        return this[this.length - 1]
    }
}

if (!HTMLElement.prototype.toImage) {
    HTMLElement.prototype.toImage = async function (options) {
        // if not provided the promise will return
        // the canvas.
        var { type, filename } = options || {}
        var fileExt = DEFAULT_CANVAS_IMAGE_TYPE.split('/')[1]
        filename = filename || `image.${fileExt}`
        type = (type || 'file').toLowerCase()

        var canvas = await html2canvas(this)
        if (type == 'canvas') {
            return canvas
        }

        var base64Url = canvas.toDataURL(DEFAULT_CANVAS_IMAGE_TYPE)
        if (type == 'dataurl') {
            return base64Url
        }

        // Create a Blob object from the Uint8Array
        const blob = await fetch(base64Url).then((res) => res.blob())
        if (type == 'blob') {
            return blob
        }

        // Create a File object from the Blob
        return new File([blob], filename, {
            type: DEFAULT_CANVAS_IMAGE_TYPE
        })
    }
}

if (!HTMLElement.prototype.findScrollableParent) {
    HTMLElement.prototype.findScrollableParent = function () {
        var parent = this.parentNode
        if (parent == null) {
            return null
        }
        if (parent.scrollHeight > parent.clientHeight) {
            return parent
        } else {
            return parent.findScrollableParent()
        }
    }
}

if (!HTMLElement.prototype.findNext) {
    HTMLElement.prototype.findNext = function (query) {
        if (this.nextElementSibling instanceof HTMLElement) {
            var firstchild = this.nextElementSibling.querySelector(query)
            if (firstchild) {
                return firstchild
            } else {
                return this.nextElementSibling.findNext(query)
            }
        } else if (this.parentElement instanceof HTMLElement) {
            return this.parentElement.findNext(query)
        } else {
            return null
        }
    }
}

if (!HTMLElement.prototype.findPrevious) {
    HTMLElement.prototype.findPrevious = function (query, depth) {
        if (this.previousElementSibling instanceof HTMLElement) {
            var lastchild = this.previousElementSibling.querySelectorAll(query).last()
            if (lastchild) {
                return lastchild
            } else {
                return this.previousElementSibling.findPrevious(query)
            }
        } else if (this.parentElement instanceof HTMLElement) {
            return this.parentElement.findPrevious(query)
        } else {
            return null
        }
    }
}

if (!HTMLElement.prototype.nextFormField) {
    HTMLElement.prototype.nextFormField = function (query) {
        return this.findNext(
            'input:not([type="hidden"]):not([disabled]), button:not([type="hidden"]):not([disabled])'
        )
    }
}

if (!HTMLElement.prototype.previousFormField) {
    HTMLElement.prototype.previousFormField = function (query) {
        return this.findPrevious(
            'input:not([type="hidden"]):not([disabled]), button:not([type="hidden"]):not([disabled])'
        )
    }
}

const promisedEvent = function (element, event) {
    const func = function (resolve, reject) {
        element.addEventListener(event, function (e) {
            resolve(e)
        })
    }
    return new Promise(func)
}

if (!HTMLElement.prototype.promisedEvent) {
    HTMLElement.prototype.promisedEvent = function (event) {
        return promisedEvent(this, event)
    }
}

if (!HTMLDocument.prototype.promisedEvent) {
    HTMLDocument.prototype.promisedEvent = function (event) {
        return promisedEvent(this, event)
    }
}

if (!window.promisedEvent) {
    window.promisedEvent = function (event) {
        return promisedEvent(this, event)
    }
}

if (!HTMLElement.prototype.getScrollParent) {
    HTMLElement.prototype.getScrollParent = function () {
        var parent = this.parentNode
        if (parent) {
            if (parent.scrollHeight > parent.offsetHeight) {
                return parent
            } else if (parent != null) {
                return parent.getScrollParent()
            }
        }
        return null
    }
}
